var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('workspace-topbar'),_c('workspace-menubar'),_c('div',{staticClass:"page-wrapper"},[_c('router-view'),_c('workspace-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }